import Component from '@glimmer/component';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

export default class MergeContactsCopyPasteButton extends Component {
  <template>
    <button
      ...attributes
      type='button'
      class='btn btn-link py-0 pl-0 pr-2 -tw-mt-1 svg-icon'
    >
      {{svgJar 'arrow-left-solid'}}
    </button>
  </template>
}
